import { render, staticRenderFns } from "./order_update.vue?vue&type=template&id=ee2108b0&scoped=true&"
import script from "./order_update.vue?vue&type=script&lang=js&"
export * from "./order_update.vue?vue&type=script&lang=js&"
import style0 from "./order_update.vue?vue&type=style&index=0&id=ee2108b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2108b0",
  null
  
)

export default component.exports